module.exports = __webpack_public_path__ + "img/alarm_2.svg";